import { SERVER_URL } from '../shared/constants';
import axios from 'axios';
import store from '../redux/store';

const api = axios.create({
  baseURL: SERVER_URL
});

api.interceptors.request.use(async (config) => {
  const state = store.getState();
  const token = state.sessao.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (!error.response) {
      // console.log('Não foi possível conectar com servidor.');
      return Promise.reject({
        data:
          'Não foi possível estabelecer a conexão com o servidor. \nPor favor, entre em contato com o suporte.'
      });
    }

    return Promise.reject(error.response);
  }
);

export default api;
